import { render } from "./LogoutButton.vue?vue&type=template&id=6f5eca1a&scoped=true&ts=true"
import script from "./LogoutButton.vue?vue&type=script&lang=ts"
export * from "./LogoutButton.vue?vue&type=script&lang=ts"

import "./LogoutButton.vue?vue&type=style&index=0&id=6f5eca1a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5eca1a"],['__file',"src/components/list-items/LogoutButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f5eca1a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f5eca1a', __exports__)) {
    api.reload('6f5eca1a', __exports__)
  }
  
  module.hot.accept("./LogoutButton.vue?vue&type=template&id=6f5eca1a&scoped=true&ts=true", () => {
    api.rerender('6f5eca1a', render)
  })

}


export default __exports__